var escape = require("../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon-tab[data-v-34e40da9]{width:35px}.icon[data-v-34e40da9]{width:30px;height:30px;display:block;background:transparent no-repeat 50%}.icon-featured[data-v-34e40da9]{background-image:url(" + escape(require("../../img/icon-featured.svg")) + ")}.icon-life[data-v-34e40da9]{background-image:url(" + escape(require("../../img/icon-life.svg")) + ")}.icon-sports[data-v-34e40da9]{background-image:url(" + escape(require("../../img/icon-sports.svg")) + ")}.icon-entertainment[data-v-34e40da9]{background-image:url(" + escape(require("../../img/icon-entertainment.svg")) + ")}.icon-other[data-v-34e40da9]{background-image:url(" + escape(require("../../img/icon-other.svg")) + ")}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-34e40da9","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/Footer.vue
// module id = mpUg
// module chunks = 46